/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_yt_hd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If a video was uploaded at low resolution or is older, YouTube may not produce a 1280×720 thumbnail. In that case, the next-largest available size is shown.`)
};

const es_yt_hd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si un video se subió con baja resolución o es antiguo, YouTube puede no generar una miniatura de 1280×720. En ese caso, se muestra el siguiente tamaño disponible más grande.`)
};

const de_yt_hd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wenn ein Video in niedriger Auflösung hochgeladen wurde oder älter ist, erzeugt YouTube möglicherweise kein 1280×720-Thumbnail. In diesem Fall wird die nächstgrößere verfügbare Größe angezeigt.`)
};

const nl_yt_hd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Als een video in een lage resolutie is geüpload of ouder is, genereert YouTube mogelijk geen thumbnail van 1280×720. In dat geval wordt het eerstvolgende beschikbare formaat getoond.`)
};

const fr_yt_hd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Si une vidéo a été mise en ligne en basse résolution ou qu’elle est ancienne, YouTube peut ne pas produire de miniature en 1280×720. Dans ce cas, la taille disponible la plus grande suivante est affichée.`)
};

const it_yt_hd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se un video è stato caricato a bassa risoluzione o è più vecchio, YouTube potrebbe non generare una miniatura a 1280×720. In questo caso, viene mostrata la dimensione disponibile più grande successiva.`)
};

const pt_br2_yt_hd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se um vídeo foi enviado em baixa resolução ou é mais antigo, o YouTube pode não gerar uma thumbnail em 1280×720. Nesse caso, é exibido o maior tamanho disponível em seguida.`)
};

const pt_yt_hd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se um vídeo foi carregado em baixa resolução ou é mais antigo, o YouTube pode não gerar uma miniatura de 1280×720. Nesse caso, é mostrado o tamanho maior seguinte disponível.`)
};

const ja_yt_hd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`動画が低解像度でアップロードされた場合や古い動画の場合、YouTubeが1280×720のサムネイルを生成しないことがあります。その場合は、次に大きい利用可能なサイズが表示されます。`)
};

const zh_yt_hd_faq2_a = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`如果视频以低分辨率上传，或者视频较旧，YouTube 可能不会生成 1280×720 的缩略图。这种情况下，会显示次大的可用尺寸。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const yt_hd_faq2_a = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.yt_hd_faq2_a(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("yt_hd_faq2_a", locale)
	if (locale === "en") return en_yt_hd_faq2_a(inputs)
	if (locale === "es") return es_yt_hd_faq2_a(inputs)
	if (locale === "de") return de_yt_hd_faq2_a(inputs)
	if (locale === "nl") return nl_yt_hd_faq2_a(inputs)
	if (locale === "fr") return fr_yt_hd_faq2_a(inputs)
	if (locale === "it") return it_yt_hd_faq2_a(inputs)
	if (locale === "pt-BR") return pt_br2_yt_hd_faq2_a(inputs)
	if (locale === "pt") return pt_yt_hd_faq2_a(inputs)
	if (locale === "ja") return ja_yt_hd_faq2_a(inputs)
	return zh_yt_hd_faq2_a(inputs)
};